/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/**
 * Defines the Design Language System (DLS) Material More Vert Icon component.
 */
export const MaterialMoreVertIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path fillRule='evenodd' clipRule='evenodd' d='M7.99984 5.33366C8.73317 5.33366 9.33317 4.73366 9.33317 4.00033C9.33317 3.26699 8.73317 2.66699 7.99984 2.66699C7.2665 2.66699 6.6665 3.26699 6.6665 4.00033C6.6665 4.73366 7.2665 5.33366 7.99984 5.33366ZM7.99984 6.66699C7.2665 6.66699 6.6665 7.26699 6.6665 8.00033C6.6665 8.73366 7.2665 9.33366 7.99984 9.33366C8.73317 9.33366 9.33317 8.73366 9.33317 8.00033C9.33317 7.26699 8.73317 6.66699 7.99984 6.66699ZM6.6665 12.0003C6.6665 11.267 7.2665 10.667 7.99984 10.667C8.73317 10.667 9.33317 11.267 9.33317 12.0003C9.33317 12.7337 8.73317 13.3337 7.99984 13.3337C7.2665 13.3337 6.6665 12.7337 6.6665 12.0003Z' fill={iconColor} />
    </svg>
  );
};

export default MaterialMoreVertIcon;
